// extracted by mini-css-extract-plugin
export default {"fullWidth":"bn-z","image":"cn-z","lazyLoadPicture":"dn-z","lazyLoadSpinner":"en-z","lazyLoadSpin":"fn-z","lazyLoadImage":"gn-z","hasStyledAspectRatio":"hn-z"};